import { Component, NgModule } from '@angular/core';
import { IdentityTypeComponent } from './identity_type.component';
import { SharedModule } from '../../shared/shared.module';
import { IdentityTypeService } from './identity_type.service';
import { IdentityService } from '../../hospitalSetup/identity-type/identity.service';

//services


@NgModule({
    imports: [SharedModule],
    declarations: [IdentityTypeComponent],
    exports:[IdentityTypeComponent],
    providers: [IdentityService, IdentityTypeService]
})
export class IdentityTypesComponent { }
